<template>
  <div>
    <div v-if="conditions.screen==screens.list.value" class="mt-24px w-100">
      <div class="d-flex justify-content-between align-items-center">
        <div class="dialer-edit-title">Groups</div>
        <b-button class="newButton" variant="primary" @click="conditions.screen=screens.add.value">
          <vb-icon icon="squared-add-icon" height="38px" width="38px" />
          <span class="newButton-textPart">Add group</span>
        </b-button>
      </div>
      <vb-table 
        :isListEmpty="response.groups.length==0"
        :listLength="response.groups.length"
        :loading="api.get_groups.send" 
        class="latestTableDesign-withBlackBorders-again hasSoundFiles"
      >
        <tr slot="header">
          <th class="dialer-has-sort py-3 border-0">
            <span>Title</span>
          </th>
          <th class="dialer-has-sort py-3 text-center dialer-col-center">
            <span>Color</span>
          </th>
          <th class="dialer-has-sort py-3 dialer-col-right">
            
          </th>
        </tr>
        <template #body="{ start, end }">
          <tr v-for="(group, index) in response.groups" :key="group.id" v-show="index >= start && index <= end">
            <td class="dialer-row-title">{{ group.name }}</td>
            <td class="dialer-has-sort text-center dialer-col-center">
              <div class="createSpace-selectColor-container justify-content-center">
                <div 
                  class="createSpace-selectColor-item selected "
                  :class="{
                    'TransparentSelected': group.color == 'rgba(0,0,0,0)'
                  }" 
                  :style="`background-color:${group.color};`"
                >
                </div>
              </div>
            </td>
            <td class="dialer-has-sort dialer-col-right">
              <div class="d-flex justify-content-end align-items-center filterDD dropdownVersion whiteBGinputWithGreyRoundedBorder buttonHeightAuto buttonWidthAuto">
                <b-dropdown toggle-class="p-0" no-caret :disabled="!!api.remove_group.send" class="w-auto" right>
                  <template #button-content>
                    <vb-icon icon="todo-three-dots-vertical-icon" variant="dark" class="mx-auto todo-three-dots-vertical-icon" width="6px" height="18px"/>
                  </template>
                  <b-dropdown-item @click="setUpdate(group)">Edit</b-dropdown-item>
                  <b-dropdown-item 
                    @click="$modal.show('TodoTaskMove',{ 
                      moved: true, 
                      select: 'group',
                      space_id: space_id,
                      payload: { 
                        group_id: 
                        group.id, 
                        flag: 'group' 
                      } 
                    })"
                  >Move task</b-dropdown-item>
                  <b-dropdown-item v-if="group.created_by" @click="remove(group)">Delete</b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </template>
        <template #loading>
          <tr v-for="n in 5" :key="n">
            <td>
              <div class="d-flex align-items-center w-fit-content">
                <div class="latestShimmerDesign" style="height:21px;width:80px;"></div>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center w-fit-content mx-auto">
                <div class="md-mar-left latestShimmerDesign" style="height:21px;width:21px;"></div>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center justify-sontent-end w-fit-content ml-auto">
                <div class="latestShimmerDesign" style="height:16px;width:70px;"></div>
              </div>
            </td>
          </tr>
        </template>
      </vb-table>
    </div>
    <form @submit.prevent="create()" v-if="conditions.screen==screens.add.value" class="createSpace-greyBox mt-24px">
      <b-alert :show="!!api.create_group.error_message" variant="danger">{{ api.create_group.error_message }}</b-alert>
      <div class="whiteBGinputWithGreyRoundedBorder">
        <label>Group name</label>
        <input 
          class="w-100 bg-white" 
          type="text" 
          placeholder="Group name" 
          v-model="forms.create_group.name"
          :disabled="api.create_group.send"
          :maxlength="$v.forms.create_group.name.$params.maxLength.max"
        />
        <p 
          v-if="(forms.create_group.submitted && $v.forms.create_group.name.$invalid) || api.create_group.validation_errors.name"
          class="mb-1 text-small text text-danger animated bounceIntop"
        >
          <span v-if="!$v.forms.create_group.name.required">* Group name is required</span>
          <span v-else-if="!$v.forms.create_group.name.minLength">* Group name should be minimum {{ $v.forms.create_group.name.$params.minLength.min }} character</span>
          <span v-else-if="!$v.forms.create_group.name.maxLength">* Group name can be maximum {{ $v.forms.create_group.name.$params.maxLength.max }} character</span>
          <span v-for="(em, index) in api.create_group.validation_errors.name" :key="index">* {{ em }}</span>
        </p>
      </div>
      <div class="whiteBGinputWithGreyRoundedBorder mt-20px">
        <label>Choose color</label>
        <div class="createSpace-selectColor-container">
          <div v-for="(color,i) in colors" :key="i" class="createSpace-selectColor-item-container" @click="api.create_group.send ? '' : forms.create_group.color=color">
            <div 
              class="createSpace-selectColor-item"
              :class="{
                'selected': forms.create_group.color==color,
                'TransparentSelected': color == 'rgba(0,0,0,0)',
              }"
              :style="`background-color:${color};`"
            >
              <vb-icon v-if="color=='rgba(0,0,0,0)'" icon="todo-transparentColored-icon" height="28px" width="30px" />
            </div>
          </div>
        </div>
        <p 
          v-if="(forms.create_group.submitted && $v.forms.create_group.color.$invalid) || api.create_group.validation_errors.color" 
          class="mb-1 text-small text text-danger animated bounceIntop"
        >
          <span v-if="!$v.forms.create_group.color.required">* Color is required</span>
          <span v-else-if="!$v.forms.create_group.color.validColor">* Color is invalid</span>
          <span v-for="em in api.create_group.validation_errors.color" :key="em">* {{ em }}</span>
        </p>
      </div>
      <div class="w-100 d-flex justify-content-end mt-20px">
        <button class="fullWidthDoneButton" type="submit">
          Add
        </button>
      </div>
    </form>
    <form @submit.prevent="update()" v-if="conditions.screen==screens.update.value" class="createSpace-greyBox mt-24px">
      <b-alert :show="!!api.update_group.error_message" variant="danger">{{ api.update_group.error_message }}</b-alert>
      <div class="whiteBGinputWithGreyRoundedBorder">
        <label>Group name</label>
        <input 
          class="w-100 bg-white" 
          type="text" 
          placeholder="Group name" 
          v-model="forms.update_group.name"
          :disabled="api.update_group.send"
          :maxlength="$v.forms.update_group.name.$params.maxLength.max"
        />
        <p 
          v-if="(forms.update_group.submitted && $v.forms.update_group.name.$invalid) || api.update_group.validation_errors.name"
          class="mb-1 text-small text text-danger animated bounceIntop"
        >
          <span v-if="!$v.forms.update_group.name.required">* Group name is required</span>
          <span v-else-if="!$v.forms.update_group.name.minLength">* Group name should be minimum {{ $v.forms.update_group.name.$params.minLength.min }} character</span>
          <span v-else-if="!$v.forms.update_group.name.maxLength">* Group name can be maximum {{ $v.forms.update_group.name.$params.maxLength.max }} character</span>
          <span v-for="(em, index) in api.update_group.validation_errors.name" :key="index">* {{ em }}</span>
        </p>
      </div>
      <div class="whiteBGinputWithGreyRoundedBorder mt-20px">
        <label>Choose color</label>
        <div class="createSpace-selectColor-container">
          <div v-for="(color,i) in colors" :key="i" class="createSpace-selectColor-item-container" @click="api.update_group.send ? '' : forms.update_group.color=color">
            <div 
              class="createSpace-selectColor-item"
              :class="{
                'selected': forms.update_group.color==color,
                'TransparentSelected': color == 'rgba(0,0,0,0)',
              }"
              :style="`background-color:${color};`"
            >
              <vb-icon v-if="color=='rgba(0,0,0,0)'" icon="todo-transparentColored-icon" height="28px" width="30px" />
            </div>
          </div>
        </div>
        <p 
          v-if="(forms.update_group.submitted && $v.forms.update_group.color.$invalid) || api.update_group.validation_errors.color" 
          class="mb-1 text-small text text-danger animated bounceIntop"
        >
          <span v-if="!$v.forms.update_group.color.required">* Color is required</span>
          <span v-else-if="!$v.forms.update_group.color.validColor">* Color is invalid</span>
          <span v-for="em in api.update_group.validation_errors.color" :key="em">* {{ em }}</span>
        </p>
      </div>
      <div class="w-100 d-flex justify-content-end mt-20px">
        <button type="submit" class="fullWidthDoneButton">
          Update
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { VOIP_API } from '@/utils'
import { mapGetters } from 'vuex'
import required from 'vuelidate/lib/validators/required'
import minLength from 'vuelidate/lib/validators/minLength'
import maxLength from 'vuelidate/lib/validators/maxLength'
import validateColor from 'validate-color'
import { APP_COLORS } from '@/constants'
const screens = {
  add: {
    text: 'Add',
    value: 'add',
  },
  update: {
    text: 'Update',
    value: 'update',
  },
  list: {
    text: 'List',
    value: 'list',
  },
}
export default {
  name: 'Groups',
  props: {
    space_id: {
      type: [String,Number],
      default: '',
      require: true,
    },
  },
  data() {
    return {
      forms: {
        create_group: this.$helperFunction.formInstance({
          data: {
            name: '',
            color: APP_COLORS[0],
          },
        }),
        update_group: this.$helperFunction.formInstance({
          data: {
            name: '',
            color: APP_COLORS[0],
          },
        }),
      },
      api: {
        get_groups: this.$helperFunction.apiInstance({  }),
        create_group: this.$helperFunction.apiInstance({ 
          validation_errors: true, 
          error_message: true, 
        }),
        update_group: this.$helperFunction.apiInstance({
          validation_errors: true, 
          error_message: true, 
        }),
        remove_group: this.$helperFunction.apiInstance({
          send: '',
        }),
      },
      response: {
        groups: [],
      },
      conditions: {
        screen: screens.list.value,
        updated_id: '',
      },
    }
  },
  inject: [
    'appNotify',
  ],
  computed: {
    ...mapGetters([
      'getCurrentUser'
    ]),
    colors(){ return APP_COLORS },
    screens(){ return screens },
  },
  validations: {
    forms: {
      create_group: {
        name: {
          required: required,
          minLength: minLength(3),
          maxLength: maxLength(15),
        },
        color: {
          required: required,
          validColor: (value) => { return validateColor(value) },
        },
      },
      update_group: {
        name: {
          required: required,
          minLength: minLength(3),
          maxLength: maxLength(15),
        },
        color: {
          required: required,
          validColor: (value) => { return validateColor(value) },
        },
      },
    }
  },
  watch: {
    "conditions.screen"(screen,old_screen){
      if(old_screen==screens.update.value){
        this.conditions.updated_id=''
        this.conditions.type_update=true
        this.forms.update_group.reset()
        this.api.update_group.reset()
      } else if(old_screen==screens.add.value) {
        this.api.create_group.reset()
        this.forms.create_group.reset()
      }
    },
  },
  methods: {
    async getGroups(){
      if(this.api.get_groups.send) return;
      try {
        this.api.get_groups.send=true
        const { data: { data } } = await VOIP_API.endpoints.taskgroups.list({
          uid: this.getCurrentUser.uid,
          accountcode: this.getCurrentUser.account,
          space_id: this.space_id,
        })
        this.response.groups = data ?? []
        this.$emit('group-count',this.response.groups.length ?? 0)
      } catch (ex) {
        this.appNotify({
          message: ex.own_message,
          type: 'danger',
        })
      } finally {
        this.api.get_groups.send=false
      }
    },
    async create(){
      this.forms.create_group.submitted=true
      this.$v.forms.create_group.$touch()
      if(this.$v.forms.create_group.$invalid || this.api.create_group.send) return;
      try {
        this.api.create_group.send=true
        this.api.create_group.validation_errors={}
        this.api.create_group.error_message=''
        await VOIP_API.endpoints.taskgroups.create({
          name: this.forms.create_group.name,
          color: this.forms.create_group.color,
          uid: this.getCurrentUser.uid,
          accountcode: this.getCurrentUser.account,
          space_id: this.space_id,
        })
        this.getGroups()
        this.conditions.screen=screens.list.value
        this.appNotify({
          message: 'Successfully created',
          type: 'success',
        })
        this.$emit('create')
      } catch (ex) {
        this.api.create_group.error_message=ex.own_message ?? ''
        this.api.create_group.validation_errors=ex.own_errors ?? []
      } finally {
        this.api.create_group.send=false
        this.forms.create_group.submitted=false
      }
    },
    async remove(group){
      const group_id = group.id
      if(this.api.remove_group.send) return;
      try {
        this.api.remove_group.send=group.id
        const { confirm } = await this.$appConfirmation({
          title: "WARNING",
          message: `Are you sure you want to delete?`,
          variant: 'danger',
          button: {
            no: "No",
            yes: "Yes",
          },
        })
        if(!confirm) return;
        await VOIP_API.endpoints.taskgroups.delete(group_id,{
          space_id: this.space_id,
        })
        this.getGroups()
        this.$emit('remove')
      } catch (ex) {
        this.appNotify({
          message: ex.own_message,
          type: 'danger',
        })
      } finally {
        this.api.remove_group.send=''
      }
    },
    async update(){
      this.forms.update_group.submitted=true
      this.$v.forms.update_group.$touch()
      if(this.$v.forms.update_group.$invalid || this.api.update_group.send) return;
      try {
        this.api.update_group.send=true
        this.api.update_group.error_message=''
        this.api.update_group.validation_errors={}
        await VOIP_API.endpoints.taskgroups.update(this.conditions.updated_id,{
          name: this.forms.update_group.name,
          color: this.forms.update_group.color,
          type: this.forms.update_group.type,
          accountcode: this.getCurrentUser.account,
          uid: this.getCurrentUser.uid,
          space_id: this.space_id,
        })
        this.conditions.screen=screens.list.value
        this.getGroups()
        this.$emit('update')
      } catch (ex) {
        this.api.update_group.error_message=ex.own_message ?? ''
        this.api.update_group.validation_errors=ex.own_errors ?? {}
      } finally {
        this.forms.update_group.submitted=false
        this.api.update_group.send=false
      }
    },
    setUpdate(group){
      if(!group || this.api.remove_group.send) return;
      this.forms.update_group.name=group.name ?? ''
      this.forms.update_group.type=group.type ?? ''
      this.forms.update_group.color=group.color ?? ''
      this.conditions.type_update=group.is_global!='yes'
      this.conditions.updated_id=group.id
      this.conditions.screen=screens.update.value
    },
    back(){
      if(this.api.create_group.send) return;
      else if(this.api.update_group.send) return;
      else if(this.api.remove_group.send) return;
      else if(this.conditions.screen==screens.add.value) this.conditions.screen=screens.list.value
      else if(this.conditions.screen==screens.update.value) this.conditions.screen=screens.list.value
      else if(this.conditions.screen==screens.list.value) this.$emit('back')
    },
  },
  mounted () {
    this.getGroups();
  },
}
</script>

<style>

</style>